import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import axiosInstance from "../axiosConfig";
import DataTable from "react-data-table-component";
import "../assets/CSS/Dashboard.css";

   const initialFormData = {
    Responsible_Person: "",
    Department: "",
    LOT_ID: "",
    // ProcessName: "",
    CheckPoints: [],
    OtherDetails: "",
    CreatedBy: ""
  };
 function CheckPoints() {


  const [departments, setDepartments]   = useState([]);
  // const [activeDept, setActiveDept]     = useState("");
  const [isSidebarVisible, setIsSidebarVisible] = useState(true);
  const [availableCheckpoints, setAvailableCheckpoints] = useState([]);
  const [showModal, setShowModal]       = useState(false);
  const [formData, setFormData] = useState({ ...initialFormData });
  const [evidencePhoto, setEvidencePhoto] = useState(null);
  const [formEntries, setFormEntries]   = useState([]);
  const [loading, setLoading]           = useState(false);
  const [error, setError]               = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("All");
  // const [selectedRow, setSelectedRow]   = useState(null);

  const user       = JSON.parse(localStorage.getItem("userData")) || {};
  const supervisor = user.Name       || "";
  const userDept   = user.Department || "";

    const toggleSidebar = () => {
    setIsSidebarVisible(!isSidebarVisible);
  };

    // Reset form to initial values + defaults
  const resetForm = useCallback(() => {
    setFormData({
      ...initialFormData,
      Responsible_Person: supervisor,
      Department: userDept,
      CreatedBy: supervisor
    });
  }, [supervisor, userDept]);

  // 1️⃣ Fetch departments for this supervisor
 // Fetch supervisor's departments
  const fetchDepartments = useCallback(async () => {
    try {
      const resp = await axiosInstance.get("/api/get-supervisor-departments", {
        params: { supervisor }
      });
      setDepartments(resp.data);
      resetForm();
    } catch (err) {
      console.error("Error loading departments:", err);
      setError("Could not load departments.");
    }
  }, [supervisor, resetForm]);
  // 2️⃣ Fetch available checkpoints whenever Department changes
  useEffect(() => {
    if (!formData.Department) {
      setAvailableCheckpoints([]);
      return;
    }
    axiosInstance
      .get("/api/get-department-checkpoints", {
        params: {
          supervisor,
          department: formData.Department
        }
      })
      .then(res => setAvailableCheckpoints(res.data))
      .catch(err => {
        console.error("Error loading checkpoints:", err);
        setError("Could not load checkpoints.");
      });
  }, [formData.Department, supervisor]);

  // 3️⃣ Fetch all submitted form entries (filtered to your dept)
  //  const fetchFormEntries = useCallback(async () => {
  //   try {
  //     const resp = await axiosInstance.get("/api/get-CheckPoint-FormData");
  //     const entries = resp.data.filter(e => e.Department === userDept);
  //     setFormEntries(entries);
  //   } catch (err) {
  //     console.error("Error loading submissions:", err);
  //     setError("Could not load submission data.");
  //   }
  // }, [userDept]);

  // after: filter by CreatedBy (the supervisor’s name)
const fetchFormEntries = useCallback(async () => {
  try {
    const resp = await axiosInstance.get("/api/get-CheckPoint-FormData");
    // only rows where CreatedBy matches the logged-in user
    const entries = resp.data.filter(e => e.CreatedBy === supervisor);
    setFormEntries(entries);
  } catch (err) {
    console.error("Error loading submissions:", err);
    // setError("Could not load submission data.");
  }
}, [supervisor]);
  // Initial load
  useEffect(() => {
    fetchDepartments();
    fetchFormEntries();
  }, [fetchDepartments, fetchFormEntries]);

  // Form field change
  const handleFormChange = e => {
    const { name, value } = e.target;
    setFormData(fd => ({ ...fd, [name]: value }));
  };

  // // Multi‐select handler
  // const handleCheckPointSelect = e => {
  //   const opts = Array.from(e.target.selectedOptions).map(o => o.value);
  //   setFormData(fd => ({ ...fd, CheckPoints: opts }));
  // };

  // Checkbox toggle
  const handleCheckToggle = cp => {
    setFormData(fd => {
      const idx = fd.CheckPoints.indexOf(cp);
      const newList = idx > -1
        ? fd.CheckPoints.filter(x => x !== cp)
        : [...fd.CheckPoints, cp];
      return { ...fd, CheckPoints: newList };
    });
  };
  // Submit handler
  const handleFormSubmit = async e => {
    e.preventDefault();
    if (formData.CheckPoints.length === 0) {
      alert("Please select at least one checkpoint");
      return;
    }
    if (!evidencePhoto) {
      alert("Please upload an evidence photo");
      return;
    }
    setLoading(true);
    try {
      const submitData = new FormData();
      submitData.append("Responsible_Person", formData.Responsible_Person);
      submitData.append("Department", formData.Department);
      submitData.append("LOT_ID", formData.LOT_ID);
      submitData.append("CheckPoints", JSON.stringify(formData.CheckPoints));
      submitData.append("OtherDetails", formData.OtherDetails);
      submitData.append("CreatedBy", formData.CreatedBy);
      submitData.append("Remarks", formData.Remarks || "");
      submitData.append("EvidencePhoto", evidencePhoto);

      await axiosInstance.post("/api/submit-checkpoint", submitData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert("Submitted successfully");
      setShowModal(false);
      setEvidencePhoto(null);
      fetchFormEntries();
    } catch (err) {
      console.error("Submission error:", err);
      alert("Submission failed");
    } finally {
      setLoading(false);
    }
  };
  // Delete handler
  // const handleDelete = async id => {
  //   if (!window.confirm("Are you sure you want to delete this entry?")) return;
  //   try {
  //     await axiosInstance.delete(`/api/delete-checkpoint/${id}`);
  //     fetchFormEntries();
  //   } catch (err) {
  //     console.error("Delete error:", err);
  //     alert("Failed to delete entry");
  //   }
  // };

  // Filter Logic
  const filteredEntries = formEntries.filter((entry) => {
    const matchesSearch = 
      (entry.LOT_ID || "").toLowerCase().includes(searchTerm.toLowerCase()) ||
      (entry.CheckPoints || "").toLowerCase().includes(searchTerm.toLowerCase());
    
    const status = entry.Status || "Pending";
    const matchesStatus = statusFilter === "All" || status === statusFilter;
    
    return matchesSearch && matchesStatus;
  });

  // Columns for the DataTable
  const columns = [
    // { name: "ID",         selector: row => row.id,                 sortable: true },
    { name: "Responsible Person",     selector: row => row.Responsible_Person, sortable: true, wrap: true },
    { name: "Department", selector: row => row.Department,         sortable: true, wrap: true },
    { name: "LOT ID",     selector: row => row.LOT_ID,             sortable: true, wrap: true, minWidth: "200px" },
    // { name: "Process",    selector: row => row.ProcessName,        sortable: true },
    { name: "Checkpoint", selector: row => (
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.CheckPoints}>
        {row.CheckPoints}
      </span>),        sortable: true, wrap: true, minWidth: "250px" },
     { name: "Details", selector: row =>(
        <span
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        title={row.OtherDetails}
        >
     {row.OtherDetails}
        </span>
    ), wrap: true },
   { name: "Remarks", selector: (row) =>(
    <span
    data-bs-toggle="tooltip"
    data-bs-placement="top"
    title={row.Remarks}
    >
    {row.Remarks || "N/A"}
    </span>
    ), sortable: true },
    { name: "Evidence", selector: row => {
      const IMAGE_BASE_URL = process.env.REACT_APP_API_BASE_PATH || "http://localhost:5000";
      return row.EvidencePhoto ? (
        <a href={`${IMAGE_BASE_URL}/${row.EvidencePhoto}`} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-primary py-0 px-2" style={{ fontSize: "12px" }}>
          <i className="bi bi-image me-1"></i>View
        </a>
      ) : (
        <span className="text-muted small">N/A</span>
      )
    }, sortable: false },
   {
    name: "Status",
    width: "120px",
    selector: (row) => row.Status || "N/A",
    sortable: true,
    cell: (row) => {
      const status = row.Status || "N/A";
      let bgColor = "transparent";
      let textColor = "black";
      let textbold = "normal";       // ← initialize here

      if (status === "Approved") {
        bgColor = "green";
        textColor = "white";
        textbold = "bold";  
      } else if (status === "Pending") {
        bgColor = "#fff3cd";
        textColor = "#856404";
        textbold = "bold";          // now this will work
      }

      return (
        <span
          style={{
            backgroundColor: bgColor,
            color: textColor,
            borderRadius: "4px",
            display: "inline-block",
            padding: "4px 12px",
            minWidth: "70px",
            textAlign: "center",
            fontSize: "12px",
            fontWeight: textbold,    // uses the declared variable
            whiteSpace: "nowrap"
          }}
        >
          {status}
        </span>
      );
    },
  },
    { name: "Created At", selector: row => row.CreatedAt,          sortable: true },
    { name: "Created By", selector: row => row.CreatedBy,          sortable: true }
    //  {
    //   name: "Actions",
    //   cell: row => (
    //     <button
    //       className="btn btn-sm btn-danger"
    //       onClick={() => handleDelete(row.id)}
    //     >
    //       Delete
    //     </button>
    //   )
    // }
  ];

  return (
    <>
    <div className="d-flex dashboard" style={{ backgroundColor: "#f4f7f6", minHeight: "100vh" }}>
       <div className={isSidebarVisible ? "sidebar-container" : "sidebar-hidden"}>
        <Sidebar />
      </div>
      <div className="flex-grow-1 d-flex flex-column" style={{ width: isSidebarVisible ? "calc(100vw - 250px)" : "100vw", transition: "width 0.3s ease" }}>
      <Header toggleSidebar={toggleSidebar} isSidebarVisible={isSidebarVisible} />
        <main className="main-container p-4" style={{ height: "fit-content", marginTop: "75px" }}>
          
          <div className="card shadow-sm border-0 rounded-4 p-4 mb-4" style={{ backgroundColor: "rgba(255,255,255,0.85)", backdropFilter: "blur(10px)" }}>
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
              <div>
                <h3 className="fw-bold mb-1 d-flex align-items-center" style={{ color: "#4a6cf7" }}>
                  <i className="bi bi-list-check me-2" style={{ fontSize: "1.2rem" }}></i>Checkpoints
                </h3>
                <p className="text-muted mb-0" style={{ fontSize: "14px" }}>Manage and review department checkpoints</p>
              </div>
              <button
                className="btn btn-primary rounded-pill px-4 py-2 shadow-sm fw-medium d-flex align-items-center gap-2"
                style={{ background: "linear-gradient(135deg, #0d6efd, #0b5ed7)", border: "none" }}
                onClick={() => setShowModal(true)}
              >
                <i className="bi bi-plus-circle"></i> Add Checkpoints
              </button>
            </div>

            {/* Filter Bar */}
            <div className="d-flex flex-wrap gap-3 mb-4 p-3 rounded-3" style={{ backgroundColor: "#f8f9fa", border: "1px solid #e9ecef" }}>
              <div className="flex-grow-1" style={{ minWidth: "250px" }}>
                <div className="input-group shadow-sm">
                  <span className="input-group-text bg-white border-end-0 text-muted"><i className="bi bi-search"></i></span>
                  <input
                    type="text"
                    className="form-control border-start-0 ps-0"
                    placeholder="Search by LOT ID or Checkpoint text..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              <div style={{ minWidth: "200px" }}>
                <select
                  className="form-select shadow-sm"
                  value={statusFilter}
                  onChange={(e) => setStatusFilter(e.target.value)}
                >
                  <option value="All">All Statuses</option>
                  <option value="Approved">Approved</option>
                  <option value="Pending">Pending</option>
                  <option value="Rejected">Rejected</option>
                </select>
              </div>
              <button className="btn btn-outline-secondary shadow-sm px-4 fw-medium" onClick={() => { setSearchTerm(""); setStatusFilter("All"); }}>
                Clear Filters
              </button>
            </div>

            {error && <p className="text-danger fw-medium">{error}</p>}

            <div className="table-responsive rounded-3 border shadow-sm">
              <DataTable
                columns={columns}
                data={filteredEntries}
                pagination
                highlightOnHover
                pointerOnHover
                customStyles={{
                  headRow: { style: { backgroundColor: '#212529', color: '#ffffff', fontWeight: 'bold', fontSize: '14px' } },
                  cells: { style: { padding: '12px', fontSize: '13.5px' } },
                }}
              />
            </div>
          </div>

          {/* Modal moved to root level */}
        </main>
      </div>
    </div>
          {showModal && (
          <div className="modal show d-flex align-items-center justify-content-center" style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 1060, position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh" }}>
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg w-100" style={{ maxHeight: "90vh" }}>
            <form onSubmit={handleFormSubmit} className="w-100 h-100 d-flex flex-column">
              <div className="modal-content border-0 shadow-lg rounded-4 overflow-hidden" style={{ maxHeight: "100%" }}>
                <div className="modal-header bg-light border-0 px-4 py-3 flex-shrink-0">
                      <h5 className="modal-title fw-bold text-dark"><i className="bi bi-ui-checks me-2 text-primary"></i>Submit Checkpoints</h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => { setShowModal(false); resetForm(); }}
                      />
                    </div>
                    <div className="modal-body overflow-auto custom-scrollbar-table">
                      <div className="mb-3">
                      <label className="form-label">Responsible Person</label>
                      <select
                        name="Responsible_Person"
                        value={formData.Responsible_Person}
                        onChange={handleFormChange}
                        className="form-control"
                        required
                      >
                        <option value="">Select Responsible Person</option>
                        <option value="Bhopendra Choubey">Bhopendra Choubey</option>
                        <option value="VARUN">VARUN</option>
                        <option value="MONU ADMIN">MONU ADMIN</option>
                      </select>
                    </div>
                    
                        <div className="mb-3">
                          <label className="form-label">Department</label>
                          <select
                            name="Department"
                            value={formData.Department}
                            onChange={handleFormChange}
                            className="form-control"
                            required
                          >
                            <option value="">Select Department</option>
                            {departments.map(d => (
                              <option key={d} value={d}>{d}</option>
                            ))}
                          </select>
                        </div>
                        <div className="mb-3">
                          <label className="form-label">
                            LOT ID <span className="text-muted small fw-normal ms-1" style={{ fontSize: "0.85rem" }}>(Note: Please enter the full LOT ID)</span>
                          </label>
                          <input
                            type="text"
                            name="LOT_ID"
                            value={formData.LOT_ID}
                            onChange={handleFormChange}
                            className="form-control"
                            required
                          />
                        </div>
                        
                          <div className="mb-3">
                          <label className="form-label fw-semibold text-secondary">Checkpoints</label>
                          <div className="border rounded p-3 bg-light custom-scrollbar-table" style={{ maxHeight: 220, overflowY: 'auto' }}>
                            {availableCheckpoints.length > 0 ? availableCheckpoints.map(cp => (
                              <div key={cp.id} className="form-check mb-2">
                                <input
                                  className="form-check-input shadow-sm"
                                  type="checkbox"
                                  id={`cp-${cp.id}`}
                                  checked={formData.CheckPoints.includes(cp['CHECK POINT'])}
                                  onChange={() => handleCheckToggle(cp['CHECK POINT'])}
                                  style={{ cursor: "pointer" }}
                                />
                                <label className="form-check-label text-dark" htmlFor={`cp-${cp.id}`} style={{ cursor: "pointer" }}>
                                  {cp['CHECK POINT']}
                                </label>
                              </div>
                            )) : <div className="text-muted small text-center py-2">No checkpoints found for this department.</div>}
                          </div>
                        </div>
                        
                        <div className="mb-3">
                          <label className="form-label fw-semibold text-secondary">
                            Evidence Photo <span className="text-danger">*</span>
                          </label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            required
                            onChange={(e) => setEvidencePhoto(e.target.files[0])}
                          />
                        </div>

                        <div className="mb-3">
                          <label className="form-label">Other Details</label>
                          <textarea
                            name="OtherDetails"
                            value={formData.OtherDetails}
                            onChange={handleFormChange}
                            className="form-control"
                            rows={3}
                            placeholder="Enter remarks"
                          />
                        </div>
                      </div>
                      <div className="modal-footer bg-light border-0 px-4 py-3 flex-shrink-0">
                        <button
                          type="button"
                          className="btn btn-outline-secondary rounded-pill px-4"
                            onClick={() => { setShowModal(false); resetForm(); }}
                        >
                          Cancel
                        </button>
                        <button type="submit" className="btn btn-primary rounded-pill px-4 shadow-sm" disabled={loading}>
                          {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Submitting…</> : "Submit"}
                        </button>
                      </div>
              </div>
            </form>
          </div>
        </div>
          )}
    </>
  );
}

export default CheckPoints